<template>
  <div class="relative">
    <svg :viewBox="'0 0 ' + radius*2 + ' ' + radius*2" preserveAspectRatio="xMidYMid meet">
      <g>
        <circle
          v-for="(item, index) in items"
          :key="item.id"
          :style="partStyles[index]"
          ref="cel"
          :cx="radius"
          :cy="radius"
          :r="radius - Math.ceil(strokeWidth / 2)"
        />
      </g>
    </svg>
    <div
      class="absolute inset-0 flex items-center justify-center cursor-pointer"
      :class="{'text-primary-500': activeItems.length === items.length}"
      :style="{opacity: 0.1 + activeItems.length / items.length}"
      @click="openActivities"
    >
      <icon name="WaldigLogo" size="4em" :settings="{strokeWidth: 1.2}" />
    </div>
  </div>
</template>

<script>
export default {
  name: "InfoCircle",
  data() {
    return {
      circleLength: null,
      activeItems: []
    };
  },
  props: {
    items: {
      type: Array
    },
    inactiveColor: {
      type: String,
      default: "#333"
    },
    strokeWidth: {
      type: Number,
      default: 5
    },
    radius: {
      type: String,
      default: "50"
    }
  },
  components: {},
  methods: {
    getPartStyle(Item, Index) {
      let partsCount = this.items.length;
      let el = this.$refs["infocircle" + Index];
      let partLength = Math.ceil(
        ((100 / partsCount) * this.circleLength) / 100
      );
      let partStyle = {
        stroke: Item.active ? Item.color : this.inactiveColor,
        fill: "none",
        strokeWidth: Item.active ? this.strokeWidth : this.strokeWidth / 2,
        strokeDashoffset: this.circleLength * Index,
        strokeDasharray: partLength + " " + this.circleLength
      };
      return partStyle;
    },
    openActivities() {
      this.goTo("/activities");
    }
  },
  computed: {
    partStyles() {
      let partStyles = [];
      if (this.circleLength) {
        this.items.forEach((item, index) => {
          partStyles.push(this.getPartStyle(item, index));
        });
      }
      return partStyles;
    }
  },
  created() {},
  mounted() {
    this.circleLength = this.$refs.cel[0].getTotalLength();
    this.activeItems = this.items.filter(e => e.active);
  }
};
</script>